// Delivery.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { clearUserFromCookie, useUser } from "../../hooks/useUser";
import { Link } from "react-router-dom";

import { OrderId, formatTaiwanDate } from "../../utils";

import "../../css/components/Delivery/Delivery.css";

import { ImageModal, Message } from "../../components";
import RoleGuard from "../../components/RoleGuard/RoleGuard";
import { RecordOrderSearch } from "../../components/Delivery/RecordOrderSearch/RecordOrderSearch";

import { updateOrder, uploadOrderImage } from "../../service/api/Order/apiOrder";
import { getDeliverRecordByDeliver } from "../../service/api/DeliveryRecord/apiDeliveryRecord";
import { completeDelivery, getDeliverOrders } from "../../service/api/StaffOrder/apiStaffOrder";
import { employeeLogout } from "../../service/api/Employee/apiEmployee";
import { roleConfig } from "../../constants/roleConfig";

const Delivery = () => {
    // 放訂單
    const navigate = useNavigate();
    const REACT_APP_API_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL;
    const { token, name, email, role, phone, name: userName, isLoggedIn, companyId } = useUser(); // 使用登入資訊

    // 設定 loginCheck 物件供 Calendar 使用
    const loginCheck = isLoggedIn ? { status: 1, name: userName } : null;
    const [orders, setOrders] = useState([]);
    const [imageModal, setImageModal] = useState({ open: false, src: "" });
    const [deliver, setDeliver] = useState({ name, email, role, phone });
    const [toggling, setToggling] = useState(null);
    const [uploadingFile, setUploadingFile] = useState({}); // orderId -> File
    const [orderStatusWindow, setOrderStatusWindow] = useState(true);
    const [records, setRecords] = useState([]); // 所有司機紀錄
    const [selectedRecord, setSelectedRecord] = useState(null); // 選中的紀錄
    const [previewImages, setPreviewImages] = useState({});
    const [staffOrder, setStaffOrder] = useState([]);


    const closeImage = () => setImageModal({ open: false, src: "" });

    useEffect(() => {
        getDeliverOrders({ companyId, type: 'monthlyTwo' })
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setStaffOrder(response.data.result);
                }
            });
    }, [companyId]);


    // 上傳圖片(不是送api)
    const handleFileChange = (orderId, fileList) => {
        if (!fileList || fileList.length === 0) return;

        const files = Array.from(fileList);

        // 建立新的預覽 URL
        const previews = files.map(file => ({
            name: file.name,
            url: URL.createObjectURL(file)
        }));

        // 更新狀態
        setUploadingFile(prev => ({ ...prev, [orderId]: files }));
        setPreviewImages(prev => ({ ...prev, [orderId]: previews }));
    };

    // 暫不啟用 導航功能
    // const handleNavigate = (order) => {
    //     const address = `${order.addressCity}${order.addressDistrict}${order.addressDetailed}`;
    //     const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
    //     window.open(url, "_blank");
    // };

    // 送出api 更新訂單的狀態
    const handleToggleShipped = async (order) => {
        const newVal = !order.isShipped;

        // 如果是要標記「已送達」，必須先上傳圖片
        if (newVal === true) {
            const files = uploadingFile[order.id];
            if (!files || files.length <= 0) {
                alert("請先上傳送達照片！");
                return;
            }

            const confirmAction = window.confirm("確定要標記為已送達嗎？");
            if (!confirmAction) {
                return; // 使用者取消就不執行
            }

            try {
                setToggling(order.id);
                const formData = new FormData();

                files.forEach(file => formData.append('files', file));

                formData.append("orderId", order.id);
                console.log(formData.get("orderId"))
                // 先上傳圖片
                const response = await uploadOrderImage(formData, 'order');
                if (response.status === 200 && response.data.status === 1) {

                    console.log(response.data);
                    const imgUrl = response.data.result.imagePath[0];
                    const payload = { ...order, isShipped: true, imagePath: imgUrl };

                    await updateOrder(payload);

                    alert("已送達並上傳照片！");

                    setOrders(prev => prev.map(o =>
                        o.id === order.id ? { ...o, isShipped: newVal, imagePath: newVal ? imgUrl : "" } : o
                    ));
                } else {
                    Message(response.data.message, 'warning');
                }
            } catch (err) {
                console.error(err);
                alert("上傳或更新失敗！");
            } finally {
                setToggling(null);
            }
        } else {
            // 標記回「未送達」，不用圖片
            const confirmAction = window.confirm("確定要取消已送達標記嗎？");
            if (!confirmAction) {
                return;
            }
            try {
                setToggling(order.id);
                const payload = { ...order, isShipped: false };

                await updateOrder(payload);

                alert("已標記未送達");

                setOrders(prev => prev.map(o =>
                    o.id === order.id ? { ...o, isShipped: newVal, imagePath: "" } : o
                ));
            } finally {
                setToggling(null);
            }
        }
    };

    // 當用户登入時自動取得派送紀錄
    useEffect(() => {
        const fetchDeliverRecords = async () => {
            console.log(isLoggedIn, deliver?.name);
            if (!isLoggedIn || !deliver?.name) return;
            try {
                const response = await getDeliverRecordByDeliver(deliver);
                console.log(response);

                if (response.status === 200) {
                    const resultRecords = response.data.result;

                    if (response.data.status === -1) {
                        Message(response.data.message, 'warning');
                        setOrders([]);
                        return;
                    }
                    if (!resultRecords || resultRecords.length === 0) {
                        // Message("目前沒有派送紀錄 !", 'warning');
                        setRecords([]);
                        return;
                    }

                    setRecords(resultRecords); // 設定司機紀錄
                } else {
                    alert("取得訂單失敗，請稍後再試！");
                }
            } catch (error) {
                console.error('取得派送紀錄失敗:', error);
                alert("取得訂單失敗，請稍後再試！");
            }
        };

        fetchDeliverRecords();
    }, [isLoggedIn, deliver]);

    // 簡單的司機登出
    const handleOrderLogout = async () => {
        // 檢查是否有未完成訂單
        const deliverOrderId = Number(Cookies.get("deliver_order_id"));
        if (orders.some(order => !order.isShipped)) {
            const confirmLogout = window.confirm("仍有未出貨的訂單，確定要登出嗎？");
            if (!confirmLogout) return;
        } else {
            // 送api更新紀錄為已完成
            const confirmLogout = window.confirm("已完成所有訂單，要標記完成並確定登出嗎？(標記完成後將無法修改)");
            if (!confirmLogout) return;
            // const data = {
            //     ...selectedRecord,
            //     status: 1,
            // }

            // console.log(data);
            // const response = await updateDeliveryRedcord(data);
            const response = await completeDelivery(deliverOrderId);

            if (response.status === 200 && response.data.status === 1) {
                Message('已完成所有訂單，辛苦了!');
            }
        }

        // 清空訂單 & driver 狀態，回到輸入資訊畫面
        Cookies.remove("deliver_order_id");
        setOrders([]);
        // setRecords([]);
        setSelectedRecord(null);
        // setDeliver(null);
        window.location.reload();
    };

    const handleLogout = async () => {
        try {
            if (token) {
                await employeeLogout(token);
            }

            // 清除所有用戶信息
            clearUserFromCookie();

            Message('登出成功');
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
            Message('登出失敗', 'warning');
        }
    };

    return (
        <>
            {!isLoggedIn && (
                <div className="sb-topnav navbar navbar-expand navbar-dark bg-dark justify-content-center">
                    <button className="btn btn-outline-light" onClick={() => navigate('/login')}>
                        前往登入
                    </button>
                </div>
            )}
            {

                isLoggedIn &&
                <>
                    <div className="sb-topnav navbar navbar-expand navbar-dark bg-dark justify-content-center">
                        <div className="sb-topnav navbar navbar-expand navbar-dark bg-dark justify-content-center me-2">
                            <button className="btn btn-outline-light" onClick={handleLogout}>
                                登出
                            </button>
                        </div>
                        <RoleGuard requiredRole={roleConfig['財務']}>
                            <Link className="btn btn-outline-light" to="/SKAManager">
                                前往後臺管理頁面
                            </Link>
                        </RoleGuard>
                    </div>
                </>

            }
            {
                orders.length === 0 ?
                    <RecordOrderSearch
                        records={records}
                        deliver={deliver}
                        setDeliver={setDeliver}
                        selectedRecord={selectedRecord}
                        setSelectedRecord={setSelectedRecord}
                        setOrders={setOrders}
                        staffO={staffOrder}
                        loginCheck={loginCheck} />
                    :
                    <div className="driver-orders">
                        {
                            selectedRecord &&
                            <div className="deliverReturn sb-topnav navbar fixed-top navbar-expand navbar-dark bg-dark justify-content-center">
                                <button className="btn btn-danger" onClick={e => { e.preventDefault(); window.open(selectedRecord.mapUrl, "_blank") }}>
                                    🚪 前往Google地圖
                                </button>
                            </div>
                        }
                        <div className="deliverReturn sb-topnav navbar fixed-bottom navbar-expand navbar-dark bg-dark justify-content-center">
                            {
                                orders.some(order => !order.isShipped) ?
                                    <button className="btn btn-danger" onClick={handleOrderLogout}>
                                        🚪 退出頁面
                                    </button>
                                    : <button className="btn btn-success" onClick={handleOrderLogout}>
                                        🚪 完成訂單
                                    </button>
                            }
                        </div>
                        {
                            orders.map((row) => {
                                const fullAddress = `${row.addressCity}${row.addressDistrict}${row.addressDetailed}`;
                                const dateText =
                                    typeof formatTaiwanDate === "function"
                                        ? formatTaiwanDate(row.deliveryDate)
                                        : new Date(row.deliveryDate).toLocaleDateString();

                                return (
                                    // 資訊欄header
                                    <article className="order-card" key={row.id}>
                                        <header className="order-card-header">
                                            <div className="order-id">訂單：{OrderId(row.id)}</div>
                                            <div className="order-status">
                                                <span
                                                    className={`badge ${row.isShipped ? "bg-success" : "bg-warning text-dark"
                                                        }`}
                                                >
                                                    {row.isShipped ? "已送達" : "未送達"}
                                                </span>
                                            </div>
                                        </header>

                                        {/* 資訊欄 */}
                                        <div className="order-card-body">
                                            <div className="order-left">
                                                <div className="field">
                                                    <div className="label">姓名</div>
                                                    <div className="value">{row.name}</div>
                                                </div>

                                                <div className="field">
                                                    <div className="label">手機</div>
                                                    <div className="value">
                                                        <a href={`tel:${row.phone}`}>{row.phone}</a>
                                                    </div>
                                                </div>

                                                <div className="field">
                                                    <div className="label">地址</div>
                                                    <div className="value address">{fullAddress}</div>
                                                </div>

                                                <div className="field small-row">
                                                    <div className="label">家具數量</div>
                                                    <div className="value">{row.furnitureCount} 件</div>
                                                    <div className="label">送貨日</div>
                                                    <div className="value">{dateText}</div>
                                                    <div className="label">運費</div>
                                                    <div className="value">${row.deliveryFee}</div>
                                                </div>
                                            </div>

                                            {/* 預覽圖片 */}
                                            <div className="order-right">
                                                <div className="deliveryfurniture-thumbs">
                                                    <div className="deliveryfurniture-thumbs">
                                                        {(() => {
                                                            // 先決定要顯示的圖片來源：上傳中的預覽 or 已上傳圖片
                                                            const images =
                                                                previewImages[row.id]?.map(p => p.url) ||
                                                                (Array.isArray(row.imagePath) ? row.imagePath.map(p => `${REACT_APP_API_URL}/public${p}`) : []);

                                                            if (images.length === 0) {
                                                                return <div className="thumb placeholder">無圖片</div>;
                                                            }

                                                            const maxShow = 2;
                                                            const visibleImages = images.slice(0, maxShow);
                                                            const hiddenCount = images.length - maxShow;

                                                            return (
                                                                <>
                                                                    {visibleImages.map((imgPath, i) => (
                                                                        <div
                                                                            key={i}
                                                                            className="thumb-wrapper"
                                                                            onClick={() => {
                                                                                const images =
                                                                                    previewImages[row.id]?.map(p => p.url) || // 優先用剛上傳的預覽
                                                                                    (Array.isArray(row.imagePath) ? row.imagePath.map(p => `${REACT_APP_API_URL}/public${p}`) : []); // 再用資料庫圖片
                                                                                console.log(images);

                                                                                setImageModal({
                                                                                    open: true,
                                                                                    src: null,
                                                                                    gallery: images,
                                                                                });
                                                                            }}
                                                                        >
                                                                            <img src={imgPath} alt={`圖片 ${i + 1}`} className="thumb" />
                                                                            {i === visibleImages.length - 1 && hiddenCount > 0 && (
                                                                                <div className="thumb-overlay">+{hiddenCount}</div>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </>
                                                            );
                                                        })()}
                                                    </div>

                                                </div>

                                                {/* 顯示已選檔案名稱 */}
                                                {uploadingFile[row.id] && (
                                                    <span className="file-name" style={{ marginLeft: "8px" }}>
                                                        {uploadingFile[row.id].name}
                                                    </span>
                                                )}

                                                <div className="actions">
                                                    {/* 上傳圖片按鈕、導航（只有未送達才顯示） */}
                                                    {!row.isShipped && (
                                                        <>
                                                            {/* 導航 */}
                                                            {/* <button className="btn btn-outline-primary small-btn" onClick={() => handleNavigate(row)}>
                                                                📍 導航
                                                            </button> */}

                                                            {/* 上傳圖片按鈕 */}
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                id={`upload-${row.id}`}
                                                                style={{ display: "none" }}
                                                                onChange={(e) =>
                                                                    handleFileChange(row.id, e.target.files)
                                                                }
                                                            />
                                                            <label
                                                                htmlFor={`upload-${row.id}`}
                                                                className="btn btn-outline-secondary small-btn"
                                                            >
                                                                📷 上傳照片
                                                            </label>
                                                        </>
                                                    )}

                                                    {/* 標記按鈕 */}
                                                    <button
                                                        className={`btn small-btn ${row.isShipped ? "btn-outline-success" : "btn-primary"
                                                            }`}
                                                        onClick={() => handleToggleShipped(row)}
                                                        disabled={toggling === row.id}
                                                    >
                                                        {toggling === row.id
                                                            ? "處理中..."
                                                            : row.isShipped
                                                                ? "標記未送達"
                                                                : "標記已送達"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                );
                            })
                        }

                        {/* 浮動小工具 - 訂單統計 */}
                        {(orders.length > 0 && orderStatusWindow === true) ?
                            <div className="order-status-widget">
                                <div className="close"><button className="btn-close" onClick={() => setOrderStatusWindow(false)}></button></div>

                                <div>📦 總數: {orders.length}</div>
                                <div>✅ 已送達: {orders.filter(o => o.isShipped).length}</div>
                                <div>⏳ 未送達: {orders.filter(o => !o.isShipped).length}</div>
                            </div>
                            :
                            <div className="order-status-widget" onClick={() => setOrderStatusWindow(true)}>{`<`}</div>
                        }

                        {/* 圖片放大 Modal */}
                        {imageModal.open && (
                            <ImageModal
                                image={imageModal}
                                closeImage={closeImage} />
                        )}
                    </div>
            }
        </>
    );
};

export { Delivery };
